import type { Gender } from '../api/types';
import { mascotImagePath, TRADITION_LABELS, type Tradition } from '../theme/tokens';

interface MascotWelcomeProps {
  gender: Gender | null;
  displayName: string;
  currentStreak: number;
  primaryTradition: Tradition | null;
  onDismiss: () => void;
}

/** The mascot "speaking" a personalized greeting -- the companion the user picked during
 * onboarding (or Settings), engaging with them by name each time they land on Home. */
export function MascotWelcome({ gender, displayName, currentStreak, primaryTradition, onDismiss }: MascotWelcomeProps) {
  const image = mascotImagePath(primaryTradition, gender);

  const streakLine =
    currentStreak > 0
      ? `You're on a ${currentStreak}-day streak -- let's keep it alive today.`
      : "Ready to begin today's practice?";

  const primaryLine = primaryTradition
    ? `Your ${TRADITION_LABELS[primaryTradition] ?? primaryTradition} practice is ready whenever you are.`
    : null;

  return (
    <div className="mascot-welcome-overlay" onClick={onDismiss}>
      <div className="mascot-welcome-card" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="mascot-welcome-close" onClick={onDismiss} aria-label="Dismiss">
          &times;
        </button>
        <img src={image} alt="" className="mascot-welcome-image" />
        <div className="mascot-welcome-bubble">
          <p className="mascot-welcome-greeting">Welcome back, {displayName}!</p>
          <p className="mascot-welcome-line">{streakLine}</p>
          {primaryLine && <p className="mascot-welcome-line">{primaryLine}</p>}
          <button type="button" className="btn btn-primary mascot-welcome-cta" onClick={onDismiss}>
            Let&rsquo;s go
          </button>
        </div>
      </div>
    </div>
  );
}
